module.exports = __webpack_public_path__ + "fe75621eb4fc7b4bf6e98be7bf9f2e0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/images/services/household_penetration.jpg
// module id = 1601
// module chunks = 0